<template>
  <v-card
    flat
    class="mt-md-10 mb-5 d-flex flex-column align-center">
      <v-card-title class="text-md-body-1 text-body-2">{{ titleText }}</v-card-title>
      <v-card-text class="black--text text-md-body-1 text-body-2 px-0" style="width: auto">
        <template v-if="isMemberGrantPoint">
          <a class="text-decoration-none" :href="formattedPathToMypage" target="_blank">マイページ <v-icon left color="black">mdi-account</v-icon></a>のポイント履歴をご確認ください。
        </template>
        <template v-else>
          後日<a class="text-decoration-none" :href="formattedPathToMypage" target="_blank">マイページ <v-icon left color="black">mdi-account</v-icon></a>のポイント履歴よりご確認ください。
        </template>
      </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "member-grant-point-message",
  props: {
    isMemberGrantPoint : {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      mainSiteDev: "https://opendev.valuebooks.jp",
      mainSiteProd: "https://www.valuebooks.jp",
    }
  },
  computed: {
    titleText() {
      return this.isMemberGrantPoint ? '会員登録ポイントを付与しました。' : '会員登録ポイントを後日付与します。'
    },
    isVaboo() {
      return this.$siteCode === VueConfig.siteCode.vaboo;
    },
    isVabooDev(){
      return location.href.match(/vabdev/g);
    },
    formattedPathToMypage(){
      if(this.isVaboo) {
        if(this.isVabooDev){ return this.mainSiteDev + '/mypage' }
        return this.mainSiteProd + '/mypage';
      }
      return '/mypage';
    },
  }
}
</script>
